import { publicClient, privateClient } from './client';
import { Spot } from './Spot';

const transactionsSpot = (pub: boolean) => new Spot(pub ? publicClient : privateClient);
export default transactionsSpot;
